//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { BooleanResultDTO } from 'src/app/core/interfaces/general/boolean-result';
import { EncryptionService } from './encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from './exceptions-service';
import { Guid } from 'guid-typescript';
import { HttpClientService } from './http-client-service';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class TotpService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public begin() {
    try {
      return this.httpClientService._post<{ base32Secret: string; otpauthUri: string; qrPngDataUrl: string }>
                                         (environment.eSimApi +
                                          eSimApiPaths.UsersTotp + "/" +
                                          eSimApiPaths.UsersTotpBegin, {});
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public confirm(sixDigitCode: string) {
    try {
      return this.httpClientService._post<{ recoveryCodes: string[] }>
                                         (environment.eSimApi +
                                          eSimApiPaths.UsersTotp + "/" +
                                          eSimApiPaths.UsersTotpConfirm, { sixDigitCode });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
    
  public reset2Fa(companyId: number, guid: Guid): Observable<BooleanResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.UsersTotp + "/" +
                                                               eSimApiPaths.UsersTotpReset2Fa +
                                                               "?companyIdEncSS=" + companyIdEncSS +
                                                               "&guid=" + guid, {});
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public verifyLogin(sixDigitCode: string, rememberDevice: boolean) {
    try {
      return this.httpClientService.post(environment.eSimApi +
                                         eSimApiPaths.UsersTotp + "/" +
                                         eSimApiPaths.UsersTotpVerifyLogin, { sixDigitCode, rememberDevice });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public verifyRecovery(recoveryCode: string) {
    try {
      return this.httpClientService.post(environment.eSimApi +
                                         eSimApiPaths.UsersTotp + "/" +
                                         eSimApiPaths.UsersTotpVerifyRecovery, { recoveryCode });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
